import React from "react";

import Button from "components/Button";

const ValidationErrorCell: React.FC<{
  value: { companyId: string; datasetId: string; onClick: () => void };
}> = ({ value: { companyId, datasetId, onClick } }) => {
  return (
    <div>
      {onClick && (
        <Button
          buttonName="View validation error response"
          eventProperties={{ companyId, datasetId }}
          data-testid="validation-error-button"
          label="View response"
          onClick={onClick}
          variant="secondary"
          color="interface"
          size="small"
        />
      )}
    </div>
  );
};

export default ValidationErrorCell;
